import { FaUserCircle } from "react-icons/fa";
import moment from "moment";

export const NotesEvent = ({ event }) => {
    const { createdAt, noteOwnerName, noteOwnerEmail, noteOwnerPicture, text } = event;

    return (
        <div className="history-item">
            <div className="history-item__top">
                <div className="row">
                    <div className="icon-column">
                    {noteOwnerPicture ? (
                        <div
                        className="user-avatar"
                        style={{
                            backgroundImage: `url("${noteOwnerPicture}")`,
                        }}
                        />
                    ) : (
                        <FaUserCircle size={40} color={"#606772"}></FaUserCircle>
                    )}
                    </div>
                    <div className="info-column">
                        <div className="info-row">
                            <div className="info-column-name">{noteOwnerName + ` (@${noteOwnerEmail?.split('@')[0] || noteOwnerEmail})`}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-column-text">{text}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-column-date">
                                {moment(new Date(createdAt)).isValid() && moment(new Date(createdAt)).format("DD/MM/YYYY HH:mm:ss")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    )
}